// extracted by mini-css-extract-plugin
export var conversationListItem = "_wy-2";
export var fullBleedList = "_wy-3";
export var messageText = "_wy-1";
export var previewText = "_wy-0";